import { Avatar, Button } from '@mui/material';

import UserService from '../../services/UserService';
import React, { useEffect } from 'react';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import { Box } from '@mui/system';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import { buildRedirectTranslatedUrl } from '../../lib/helperFuncs';
import HttpService from '../../services/HttpService';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { encodeRedirectUrl } from '../../lib/utils';
import { Permissions } from '../../lib/permissions';
import Cookies from 'js-cookie';
import { CookiesValues } from '../../lib/generalTypes';

const loginWPStyling = {
  color: 'white',
  fontSize: '16px',
  fontFamily: 'inherit',
  fontWeight: 700,
  position: 'relative',
  minWidth: i18n.language === 'el'
    ? '160px'
    : '129px',
  borderRadius: 0,
  '&:hover': {
    color: '#1622AA',
    background: '#EFEAE8',
    transition: 'all 277ms cubic-bezier(0.16, 0.01, 0.77, 1)',
  }
} as const;

const onHoverEffect = {
  '&:hover': {
    color: '#1622AA',
    transition: 'all 277ms cubic-bezier(0.16, 0.01, 0.77, 1)',
  }
};

const onHoverEffectList = {
  '&:hover': {
    color: '#1622AA',
    transition: 'all 277ms cubic-bezier(0.16, 0.01, 0.77, 1)',
  }
};

const onHoverEffectLogout = {
  '&:hover': {
    color: '#ca2e2e',
    transition: 'all 277ms cubic-bezier(0.16, 0.01, 0.77, 1)',
  }
};

const listContainerStyle = {
  position: 'absolute',
  top: '100%',
  zIndex: 1,
  display: 'flex',
  boxShadow: 'rgba(60, 64, 67, 0.3) 0px 1px 0px 0px, rgba(60, 64, 67, 0.15) 0px 1px 0px 1px',
  background: '#EFEAE8',
  padding: '10px',
  flexDirection: 'column',
  flexItem: 'flex-end',
} as const;

const listItemStyle = {
  textDecoration: 'none',
  fontFamily: 'inherit',
  fontWeight: 700,
  color: '#1622AA',
  margin: '15px'
} as const;

const LoginWP = () => {

  Cookies.set(CookiesValues.RLogUserSearches, 'true', { domain: '.ekkomed.gr', expires: 1000000, });
  Cookies.set(CookiesValues.RLogLoginLogout, 'true', { domain: '.ekkomed.gr', expires: 1000000, });
  Cookies.set(CookiesValues.RLogCountry, 'true', { domain: '.ekkomed.gr', expires: 1000000, });
  Cookies.set(CookiesValues.RLogFavorite, 'true', { domain: '.ekkomed.gr', expires: 1000000, });
  Cookies.set(CookiesValues.RLogRegisters, 'true', { domain: '.ekkomed.gr', expires: 1000000, });
  Cookies.set(CookiesValues.RLogApplications, 'true', { domain: '.ekkomed.gr', expires: 1000000, });
  Cookies.set(CookiesValues.RLogUserInfo, 'true', { domain: '.ekkomed.gr', expires: 1000000, });

  const isLoggedIn = UserService.isAuthenticated();
  const [userInfo, setUserInfo] = React.useState<{ fullName: string; profilePicture: string }>();
  const { t } = useTranslation();
  const [visible, setVisible] = React.useState<boolean>(false);
  const [changeIcon, setChangeIcon] = React.useState<boolean>(false);
  const setLanguage = (lang: string) => {
    //console.info(`Language changed to ${lang}`);

    i18n.changeLanguage(lang === 'en-US'
      ? 'en'
      : 'el');
  };

  const userData = async () => {
    const response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/users/user`);
    setUserInfo({
      fullName: response.data?.full_name,
      profilePicture: response.data?.profile_picture
    });
  };

  useEffect(() => {
    isLoggedIn && userData();
  }, []);

  useEffect(() => {
    // Get the initial language and set it
    const initialLang = document?.getElementsByTagName('html')?.[0]?.getAttribute('lang');
    if (initialLang) {
      setLanguage(initialLang);
    }

    // Create a new MutationObserver instance
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const observer = new MutationObserver((mutationsList, _observer) => {
      // Iterate through each mutation in the list
      for (const mutation of mutationsList) {
        // Check if the mutation is a change to the lang attribute on the html element
        if (mutation.type === 'attributes' && mutation.attributeName === 'lang') {
          // Get the new value of the lang attribute
          const mutationTarget = mutation.target as HTMLElement;
          const newLang = mutationTarget.getAttribute('lang') || '';
          setLanguage(newLang);
        }
      }
    });

    // Observe changes to the html element's attributes
    observer.observe(document.getElementsByTagName('html')[0], { attributes: true });

    // Cleanup function to disconnect the observer when the component unmounts
    return () => observer.disconnect();
  }, []);

  return (
    <>
      {
        !isLoggedIn
          ? <Button disableRipple variant='text'
            sx={{ ...loginWPStyling }}
            onClick={() => {
              const newUrl = window.location.href;
              const redirectUrl = encodeRedirectUrl(newUrl);
              window.location.href = `${buildRedirectTranslatedUrl()}/?redirectUrl=${redirectUrl}`;
            }}
          >

            <Box >
              {t('Σύνδεση/Εγγραφή')}
            </Box>

          </Button >
          : <Button disableRipple variant='text'
            sx={{ ...loginWPStyling, paddingTop: 0 }}
            onMouseEnter={() => {
              setVisible(true);
            }}
            onMouseLeave={() => {
              setVisible(false);
              setChangeIcon(false);
            }}>
            <Box display='flex' columnGap='7px'>
              {userInfo?.profilePicture ?
                <Avatar alt='My Profile Picture' src={userInfo.profilePicture}
                  sx={{ margin: 'auto', width: '35px', height: '35px', marginTop: '6px' }}
                  onMouseEnter={() => {
                    setChangeIcon(true);
                  }} />
                : <AccountCircleRoundedIcon sx={{ marginRight: '5px', width: '35px', height: '35px', marginTop: '5px', ...onHoverEffect }}
                  onMouseEnter={() => {
                    setChangeIcon(true);
                  }}
                ></AccountCircleRoundedIcon>}
              {changeIcon ?
                <ExpandLessIcon sx={{ alignItems: 'center', width: '25px', height: '25px', margin: 'auto', ...onHoverEffect }}
                  onMouseEnter={() => {
                    setChangeIcon(true);
                  }}></ExpandLessIcon>
                : <ExpandMoreIcon sx={{ alignItems: 'center', width: '25px', height: '25px', margin: 'auto', ...onHoverEffect }}
                  onMouseEnter={() => {
                    setChangeIcon(true);
                  }}></ExpandMoreIcon>}
            </Box>
            {/* {userInfo?.fullName
              ? userInfo.fullName
              : t('Το Προφίλ μου')} */}
            {visible &&
              <div style={listContainerStyle}
                onMouseLeave={() => {
                  setChangeIcon(false);
                }}>
                <a href={`${buildRedirectTranslatedUrl()}/profile`} style={listItemStyle}>
                  <Box sx={{ ...onHoverEffectList }}>
                    {t('Το προφίλ μου')}
                  </Box>
                </a>
                {UserService.hasRole([
                  Permissions.PermissionExternalLocationFavoritesReadMy,
                  Permissions.PermissionExternalProfessionalsFavoritesReadMy
                ])
                  ? <a href={`${buildRedirectTranslatedUrl()}/my-favorites`}
                    style={listItemStyle}>
                    <Box sx={{ ...onHoverEffectList }}>
                      {t('Αγαπημένα')}
                    </Box>
                  </a>
                  : null
                }
                {/* <a href={`${buildRedirectTranslatedUrl()}/my-applications`} style={listItemStyle}>
                  <Box sx={{ ...onHoverEffectList }}>
                    {t('Αιτήματα')}
                  </Box>
                </a> */}
                {/* <a href={`${buildRedirectTranslatedUrl()}/my-registrations`}
                  style={listItemStyle}>
                  <Box sx={{ ...onHoverEffectList }}>
                    {t('Καταχωρίσεις')}
                  </Box>
                </a> */}
                <Box
                  sx={{ ...listItemStyle, ...onHoverEffectLogout }}
                  onClick={() => UserService.doLogout({
                    redirectUri: i18n.language == 'en'
                      ? `${window.location.origin}`
                      : `${window.location.origin}/el/arxiki/`
                  })}>
                  {t('Αποσύνδεση')}
                </Box>
              </div>
            }
          </Button>
      }
    </>
  );
};

export default LoginWP;